import {StrategyCategoryItem} from '../../../../design-system/organisms/StrategyCategoryItem/StrategyCategoryItem';
import {StrategyViewItem} from '../../../../graphql/generated/types';
import {LOG_CLICK_EVENT} from '../../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../../logging/putTiaraObjectProps';
import {CommonItemProps} from '../../type';

export function StrategyCategory({item}: CommonItemProps) {
  const {title, count, scheme} = item as StrategyViewItem;

  return (
    <StrategyCategoryItem
      title={title || ''}
      count={count !== null ? count : undefined}
      scheme={scheme}
      className="px-8pxr"
      onClickCapture={e => LOG_CLICK_EVENT('전략카테고리_클릭', e)}
      {...putTiaraObjectProps({
        click: {
          copy: title,
          imp_provider: 'service',
          setnum: null,
        },
        customProps: {
          landing_path: scheme,
        },
      })}
    />
  );
}
